export const config = {
  apiBaseUrl:
    (import.meta.env.VITE_API_BASE_URL as string) ||
    (import.meta.env.PROD ? 'https://fuyangtong-api.jimsbond007.workers.dev' : ''),
};

export function apiUrl(path: string): string {
  const base = config.apiBaseUrl.replace(/\/$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return base ? `${base}${normalizedPath}` : normalizedPath;
}
